import { inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  type NavigationExtras,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AuthUserService } from './auth-user.service';

@Injectable({
  providedIn: 'root',
})
export class AuthAccountGuard {
  private authUserService = inject(AuthUserService);
  private router = inject(Router);

  constructor() {
    this.authUserService.authInit();
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.authUserService.account.pipe(
      take(1),
      map((account) => {
        const navigationExtras: NavigationExtras = {
          queryParams: { redirect: state.url },
        };
        if (!account) {
          // If the user is logged out, send to the "log in" page
          if (state.url === '' || state.url === '/')
            this.router.navigate(['/login']);
          else this.router.navigate(['/login'], navigationExtras);
          return false;
        }

        const pathAccountId = next.params.accountId;

        if (!pathAccountId) {
          // Simply use the account as selected
          return true;
        }
        if (pathAccountId === account.accountId) {
          // accountId matches
          return true;
        } else {
          // see if we can switch to the relevant account
          const accountExists = this.authUserService.getAccount(pathAccountId);
          if (accountExists) {
            this.authUserService.selectAccount(pathAccountId);
            return true;
          } else {
            // If the user is logged in, send to the "maybe log in" page
            this.router.navigate(['/no-access'], navigationExtras);
            return false;
          }
        }
      })
    );
  }
}
